// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3teB_","productName":"Table_productName__1hknf"};